import widgetfill from "../../../src/Utils/Images/Widgetfill.png";
import widget from "../../../src/Utils/Images/Widget.png";
import user from "../../../src/Utils/Images/User Rounded.png";
import bag from "../../../src/Utils/Images/Bag.png";
import chat from "../../../src/Utils/Images/chat.png";
import coupon from "../../../src/Utils/Images/coupon.png";
import order from "../../../src/Utils/Images/order.png";
import workout from "../../../src/Utils/Images/workout.png";
import { Box, Typography } from "@mui/material";
import links from "../../../src/Utils/Images/Link.png";
import voucher from "../../../src/Utils/Images/voucher.png";
import controller from "../../../src/Utils/Images/controller.png";
import notification from "../../../src/Utils/Images/notification.png";
import notificationfill from "../../../src/Utils/Images/notificationfill.png";
import workoutfill from "../../../src/Utils/Images/workoutfill.png";
import userfill from "../../../src/Utils/Images/User Rounded fill.png";
import bagfill from "../../../src/Utils/Images/Bag fill.png";
import chatfill from "../../../src/Utils/Images/chatfill.png";
import orderfill from "../../../src/Utils/Images/orderfill.png";
import couponfill from "../../../src/Utils/Images/coupon fill.png";
import linkwhite from "../../../src/Utils/Images/Linkwhite.png";
import voucherfill from "../../../src/Utils/Images/voucherfill.png";
import controllerfill from "../../../src/Utils/Images/Controllerfill.png";
import setting from "../../Utils/Images/Settings.png";
import settingfill from "../../Utils/Images/Settingsfill.png";
import aboutfill from "../../Utils/Images/aboutfill.png";
import about from "../../Utils/Images/about.png";
import policylogo from "../../Utils/Images/privacy.png";
import policylogofill from "../../Utils/Images/privacyfill.png";

const sidebarArray = [
  { id: 11, active: widgetfill, image: widget, title: "Dashboard", path: "/" },
  { id: 1, active: userfill, image: user, title: "Users", path: "/users" },
  { id: 2, active: bagfill, image: bag, title: "Product", path: "/product" },
  { id: 3, active: chatfill, image: chat, title: "Chat", path: "/chat" },
  { id: 4, active: orderfill, image: order, title: "Order", path: "/order" },
  {
    id: 5,
    active: couponfill,
    image: coupon,
    title: "Coupon",
    path: "/coupon",
  },
  {
    id: 6,
    image: workout,
    active: workoutfill,
    title: "Workout",
    path: "/workout",
    optionsArray: [
      { opt: "Workout Plans", path: "workoutplans" },
      { opt: "Recipe Plans", path: "recipeplans" },
      { opt: "Diet Plans", path: "dietplans" },
      { opt: "Weekly Challenges", path: "weeklychallanges" },
      { opt: "Q&A", path: "questions" },
    ],
  },

  {
    id: 7,
    active: linkwhite,
    image: links,
    title: "Home page Links",
    path: "/pagelinks",
  },
  {
    id: 8,
    active: voucherfill,
    image: voucher,
    title: "Voucher",
    path: "/voucher",
  },
  {
    id: 10,
    active: controllerfill,
    image: controller,
    title: "Controller",
    path: "/controller",
  },
  {
    id: 9,
    active: notificationfill,
    image: notification,
    title: "Notification",
    path: "/notification",
  },
  {
    id: 10,
    active: settingfill,
    image: setting,
    title: "Setting",
    path: "/setting",
  },
  {
    id: 10,
    active: policylogofill,
    image: policylogo,
    title: "Privacy Policy",
    path: "/privacy",
  },
  {
    id: 10,
    active: aboutfill,
    image: about,
    title: "About Us",
    path: "/about",
  },
];

export default sidebarArray;
const WorkoutDropdown = () => {
  return (
    <Box>
      <Typography variant="body1">Option 1</Typography>
      <Typography variant="body1">Option 2</Typography>
      <Typography variant="body1">Option 3</Typography>
    </Box>
  );
};
export { WorkoutDropdown };
